
export default {
  name: 'Hide',
  components: {},
  props: {},
  data() {
    return {
      popshow: false, // 开关
      hidedata: {},
      isclose: true
    }
  },
  computed: {
    des() {
      let t = ''
      this.hidedata?.feedbackContents?.forEach((item) => {
        t += item.content
      })
      return t
    }
  },
  watch: {
    popshow(val) {
      if (val) {
        // document.body.style.overflow = 'hidden'
        this.$nextTick(() => {
          document.body.className = 'hide-dig'
        })
      } else {
        this.$nextTick(() => {
          document.body.className = ''
        })
        // document.body.style.overflow = 'auto'
      }
    }
  },
  mounted() {
    // this.open()
  },
  methods: {
    open(SubjectId, SubjectType, fn, bool = true) {
      this.isclose = bool
      this.$api.common
        .CV3(
          {
            SubjectId, // CPD202405111655196893574230535
            SubjectType // 主体类型：（1-牌照，2-公司，3-员工）
          },
          {
            Routes: 'wikifxagg$subject_info_privacy_protection_popup'
          }
        )
        .then((res) => {
          console.log(res?.wikifxagg?.subject_info_privacy_protection_popup?.data, 7776)
          const result = res?.wikifxagg?.subject_info_privacy_protection_popup?.data
          if (result?.isShowPopUp) {
            for (const key in result?.popUp) {
              this.$set(this.hidedata, key, result?.popUp[key])
            }
            this.popshow = true
          } else {
            fn()
          }
        })
    }
  }
}
